module.exports = __webpack_public_path__ + "static/media/d3.05c3b925.jpg";